import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronDownLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 5,8.25 c -0.1919423,0 -0.3848051,0.072305 -0.53125,0.21875 -0.2928897,0.2928897 -0.2928897,0.7696103 0,1.0625 l 7,7 C 11.60935,16.67195 11.8011,16.75 12,16.75 c 0.1989,0 0.39065,-0.07805 0.53125,-0.21875 l 7,-7 c 0.2929,-0.2928897 0.2929,-0.7696103 0,-1.0625 -0.2929,-0.2928897 -0.7696,-0.2928897 -1.0625,0 L 12,14.939453 5.53125,8.46875 C 5.3848051,8.3223051 5.1919423,8.25 5,8.25 Z"
	})]
});
export default SvgChevronDownLine;
